import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { CustomFieldsOptions } from '../../../components/custom-fields/custom-fields.interface';
import { CustomersListOptions } from 'app/components/customers-list/customers-list.interface';
import { CustomFieldGroupService } from 'app/core/services/custom_fields_group/custom_fields_group.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { PropertyService } from 'app/core/services/properties/properties.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'property-summary-preview',
  templateUrl: './property-summary-preview.component.html',
  styleUrls: ['./property-summary-preview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection:ChangeDetectionStrategy?.OnPush
})
export class PropertySummaryPreviewComponent implements OnInit, OnChanges {
  @Input() propertyId: any = '';
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  object = Object;
  customFieldGroups: any = {};
  masterCustomFields: any[] = [];
  loaded: boolean = false;
  propertyDetails: any = {};
  hasAccessToOrganization: boolean;

  constructor(
    private dataCollectorService: DataCollectorService,
    private localisationService: LocalisationService,
    private utilityService: UtilityService,
    private propertyService: PropertyService,
    private customFieldServie: CustomFieldGroupService,
    private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.getPropertyDetails();
    this.hasAccessToOrganization = this.utilityService.hasModuleAccess('ORGANIZATION')
    this.changeDetectorRef.markForCheck();
  }

  closeDrawer(): void {
    this.eventEmitter.emit({ drawerClose: true });
    this.changeDetectorRef.markForCheck();
  }

  getFormattedAddress(address: any): string {
    return this.utilityService.getFormattedAddress(address);
  }

  getPropertyDetails(): void {
    this.loaded = false;
    forkJoin([
      this.dataCollectorService.getData(this.propertyService.getPropertyDetails(this.propertyId)),
      this.dataCollectorService.getData(this.customFieldServie.getModuleCustomFieldsUrl('PROPERTY'))])
      .subscribe(
        ([propertyDetails, customFields]: any) => {
          this.propertyDetails = propertyDetails.data;
          this.masterCustomFields = customFields.data;
          this.loaded = true;
          this.getCustomFieldGroups();
          this.changeDetectorRef.markForCheck();
        }, (_error: any) => {
          this.loaded = true;
          this.changeDetectorRef.markForCheck();
        });
  }

  getCustomFieldGroups(): void {
    this.customFieldGroups = this.customFieldServie.getCustomFieldGroups(this.masterCustomFields, this.propertyDetails.custom_fields);
    this.changeDetectorRef.markForCheck();
  }

  getCustomerListOptions(propertyCustomers: any[]): CustomersListOptions {
    const customers: any[] = [];
    propertyCustomers.forEach((value: any) => {
      if (value.customer) {
        customers.push(value.customer);
      }
    });
    this.changeDetectorRef.markForCheck();
    return {
      data: customers
    };
  }

  getRedirectLink(): string {
    return this.utilityService.getLink('PROPERTY', this.propertyDetails.property_uid);
  }

  getcustomFieldOptions(data: any): CustomFieldsOptions {
    return {
      data: data,
      displayInColumn: 1,
      extraClass: 'px-0',
      labelAlign: 'Left'
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.propertyId?.firstChange === false) {
      this.getPropertyDetails();
      this.changeDetectorRef.markForCheck();
    }
  }
}
